import { render, staticRenderFns } from "./UserListItem.vue?vue&type=template&id=4b19976a&scoped=true"
import script from "./UserListItem.vue?vue&type=script&lang=js"
export * from "./UserListItem.vue?vue&type=script&lang=js"
import style0 from "./UserListItem.vue?vue&type=style&index=0&id=4b19976a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b19976a",
  null
  
)

export default component.exports